<template>
    <div class="form-container">
        <!-- 위탁 신청 전에 읽어주세요 -->
        <div>
            <v-card tile elevation="0" class="grey-ef">
                <v-card-text class="pa-24 pa-md-30">
                    <div class="mb-10 mb-md-14">
                        <h4 class="tit tit--xs primary--text">* 위탁 신청 전에 읽어주세요</h4>
                    </div>
                    <div class="page-text">
                        <p>1. 심의 항목 : 작품성, 작품상태, 판매가능성, 작품가치, 판매대상 범위와의 부합성 등 다양한 측면을 고려하여 서면심의를 진행합니다</p>
                        <p>2. 심의 기간 : 접수일로부터 7일 이내 심의를 완료합니다</p>
                        <p>3. 심의 결과 안내 : 위탁신청 접수 내용을 토대로 심의 후, 위탁 가능 여부를 위탁자에게 개별 안내해 드립니다</p>
                    </div>
                </v-card-text>
            </v-card>
        </div>
        <!-- 위탁 신청 전에 읽어주세요 -->

        <!-- 위탁 신청인 정보 -->
        <div class="mt-30 mt-md-40">
            <div class="mb-10">
                <h3 class="tit tit--xs">위탁 신청인 정보</h3>
            </div>
            <div class="table-style table-style--default">
                <myinfo-modify-row label="이름">
                    <v-text-field v-model="form.meta.name" type="text" outlined persistent-placeholder hide-details class="w-100 mw-lg-500px" />
                </myinfo-modify-row>

                <myinfo-modify-row label="연락처">
                    <div class="mw-lg-500px">
                        <v-row class="row--x-small" align="center">
                            <v-col>
                                <v-select v-model="form.meta.phone1" :items="['010', '011', '016', '017', '019']" outlined hide-details></v-select>
                            </v-col>
                            <v-col cols="auto">-</v-col>
                            <v-col>
                                <v-text-field v-model="form.meta.phone2" maxlength="4" outlined hide-details @input="form.meta.phone2 = form.meta.phone2.replace(/[^0-9]/g, '')" />
                            </v-col>
                            <v-col cols="auto">-</v-col>
                            <v-col>
                                <v-text-field v-model="form.meta.phone3" maxlength="4" outlined hide-details @input="form.meta.phone2 = form.meta.phone2.replace(/[^0-9]/g, '')" />
                            </v-col>
                        </v-row>
                    </div>
                </myinfo-modify-row>
                <myinfo-modify-row label="이메일">
                    <div class="mw-lg-500px">
                        <v-row class="row--x-small" align="center">
                            <v-col>
                                <v-text-field v-model="form.meta.email1" type="text" name="email1" outlined hide-details class="w-100"></v-text-field>
                            </v-col>
                            <v-col cols="auto">@</v-col>
                            <v-col>
                                <v-text-field v-model="form.meta.email2" type="text" name="email2" outlined hide-details class="w-100"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="auto">
                                <v-select v-model="form.meta.email3" :items="[{ text: '직접입력', value: null }, 'naver.com', 'daum.com', 'google.com']" @change="form.meta.email2 = form.meta.email3" outlined hide-details class="w-100 mw-sm-160px" />
                            </v-col>
                        </v-row>
                    </div>
                </myinfo-modify-row>
            </div>
        </div>
        <!-- 위탁 신청인 정보 -->

        <!-- 위탁 작품 정보 -->
        <div class="mt-30 mt-md-40">
            <div class="mb-10">
                <h3 class="tit tit--xs">위탁 작품 정보</h3>
            </div>
            <div class="table-style table-style--default">
                <myinfo-modify-row label="작가명">
                    <v-text-field v-model="form.meta.author" outlined persistent-placeholder hide-details class="w-100 mw-lg-500px" />
                </myinfo-modify-row>
                <myinfo-modify-row label="작품명">
                    <v-text-field v-model="form.meta.subject" outlined persistent-placeholder hide-details class="w-100 mw-lg-500px" />
                </myinfo-modify-row>
                <myinfo-modify-row label="작품의 재료">
                    <v-text-field v-model="form.meta.material" outlined persistent-placeholder hide-details class="w-100 mw-lg-500px" />
                </myinfo-modify-row>
                <myinfo-modify-row label="작품의 크기">
                    <v-text-field v-model="form.meta.dimension" outlined persistent-placeholder hide-details class="w-100 mw-lg-500px" />
                </myinfo-modify-row>
                <myinfo-modify-row label="Edition">
                    <v-text-field v-model="form.meta.edition" outlined persistent-placeholder hide-details class="w-100 mw-lg-500px" />
                    <div class="mt-4">
                        <p class="page-text">* 작품이 판화인 경우에 기입해 주세요</p>
                    </div>
                </myinfo-modify-row>
                <myinfo-modify-row label="제작년도(추정)">
                    <v-text-field v-model="form.meta.year" outlined persistent-placeholder hide-details class="w-100 mw-lg-500px" />
                </myinfo-modify-row>
                <myinfo-modify-row label="작품설명">
                    <v-textarea v-model="form.meta.content" outlined persistent-placeholder hide-details />
                </myinfo-modify-row>
                <myinfo-modify-row label="기타">
                    <v-textarea v-model="form.meta.etc" outlined persistent-placeholder hide-details />
                </myinfo-modify-row>
                <myinfo-modify-row label="작품 이미지">
                    <images-input v-model="form.files" cols="2" />
                </myinfo-modify-row>
                <myinfo-modify-row label="구입가(KRW)">
                    <v-currency-field v-model="form.meta.price_bought" outlined persistent-placeholder hide-details class="w-100 mw-lg-500px" />
                </myinfo-modify-row>
                <myinfo-modify-row label="희망가(KRW)">
                    <v-currency-field v-model="form.meta.price_asking" outlined persistent-placeholder hide-details class="w-100 mw-lg-500px" />
                </myinfo-modify-row>
            </div>
        </div>
        <!-- 위탁 작품 정보 -->

        <!-- 하단버튼 -->
        <div class="mt-30 mt-md-50">
            <div class="v-btn--group v-btn--group--large">
                <v-btn x-large outlined color="grey-cb" class="w-100 mw-220px" @click="$router.go(-1)"><span class="primary--text">취소</span></v-btn>
                <v-btn x-large color="primary" class="w-100 mw-220px" @click="$emit('save')">위탁신청</v-btn>
            </div>
        </div>
    </div>
</template>

<script>
import MyinfoModifyRow from "@/components/client/ko/mypage/myinfo-modify-row.vue";
import ImagesInput from "@/components/console/dumb/images-input.vue";
export default {
    components: {
        MyinfoModifyRow,
        ImagesInput,
    },
    props: {
        value: { type: Object, default: null },
    },
    data() {
        return {
            form: this.$props.value,
        };
    },
    methods: {
        input() {
            this.$emit("input", this.form);
        },
    },
    watch: {
        value() {
            this.board = this.value;
        },

        "form.writer.email"() {
            this.$emit("input", this.form);
        },
        "form.writer.email1"() {
            this.$set(this.form.writer, "email", this.form.writer.email1 && this.form.writer.email2 ? `${this.form.writer.email1}@${this.form.writer.email2}` : null);
        },
        "form.writer.email2"() {
            this.$set(this.form.writer, "email", this.form.writer.email1 && this.form.writer.email2 ? `${this.form.writer.email1}@${this.form.writer.email2}` : null);
        },

        "form.writer.phone"() {
            this.$emit("input", this.form);
        },
        "form.writer.phone1"() {
            this.$set(this.form.writer, "phone", this.form.writer.phone1 && this.form.writer.phone2 && this.form.writer.phone3 ? `${this.form.writer.phone1}-${this.form.writer.phone2}-${this.form.writer.phone3}` : null);
        },
        "form.writer.phone2"() {
            this.$set(this.form.writer, "phone", this.form.writer.phone1 && this.form.writer.phone2 && this.form.writer.phone3 ? `${this.form.writer.phone1}-${this.form.writer.phone2}-${this.form.writer.phone3}` : null);
        },
        "form.writer.phone3"() {
            this.$set(this.form.writer, "phone", this.form.writer.phone1 && this.form.writer.phone2 && this.form.writer.phone3 ? `${this.form.writer.phone1}-${this.form.writer.phone2}-${this.form.writer.phone3}` : null);
        },

        "form.meta.email"() {
            this.$emit("input", this.form);
        },
        "form.meta.email1"() {
            this.$set(this.form.meta, "email", this.form.meta.email1 && this.form.meta.email2 ? `${this.form.meta.email1}@${this.form.meta.email2}` : null);
        },
        "form.meta.email2"() {
            this.$set(this.form.meta, "email", this.form.meta.email1 && this.form.meta.email2 ? `${this.form.meta.email1}@${this.form.meta.email2}` : null);
        },

        "form.meta.phone"() {
            this.$emit("input", this.form);
        },
        "form.meta.phone1"() {
            this.$set(this.form.meta, "phone", this.form.meta.phone1 && this.form.meta.phone2 && this.form.meta.phone3 ? `${this.form.meta.phone1}-${this.form.meta.phone2}-${this.form.meta.phone3}` : null);
        },
        "form.meta.phone2"() {
            this.$set(this.form.meta, "phone", this.form.meta.phone1 && this.form.meta.phone2 && this.form.meta.phone3 ? `${this.form.meta.phone1}-${this.form.meta.phone2}-${this.form.meta.phone3}` : null);
        },
        "form.meta.phone3"() {
            this.$set(this.form.meta, "phone", this.form.meta.phone1 && this.form.meta.phone2 && this.form.meta.phone3 ? `${this.form.meta.phone1}-${this.form.meta.phone2}-${this.form.meta.phone3}` : null);
        },
    },
};
</script>
